import React from "react";
import {
  Button,
  HStack,
  Input,
  StackProps,
  Text,
  Select,
} from "@chakra-ui/react";

type SearchMarkupProps = StackProps & {
  search: (queryString: string) => void;
  placeholder?: string;
};

/**
 * Shared markup base between different search implementations
 */
export function SearchMarkup({
  search,
  children,
  placeholder = "123456789",
  ...delegated
}: React.PropsWithChildren<SearchMarkupProps>) {
  const [queryString, setQueryString] = React.useState("");
  const [partType, setPartType] = React.useState("");

  const doSearch = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();
      if (queryString != "" && partType != "") {
        alert("Note: combination searches are currently unavailable");
      }
      search(queryString + " " + partType);
    },
    [search, queryString],
  );

  return (
    <HStack w="100%" as="form" {...delegated}>
      <Input
        placeholder={placeholder}
        size="lg"
        value={queryString}
        onChange={(event) => setQueryString(event.target.value)}
      />

      <HStack alignItems="center" justifyContent="flex-end">
        <Text>Part Type </Text>
        <Select
          maxWidth={200 / 16 + "rem"}
          onChange={({ target: { value } }) => {
            const ctype = String(value);
            if (ctype != undefined) {
              setPartType(ctype);
            }
          }}
        >
          <option disabled>~~Please Select One~~</option>
          <option value={""}>None</option>
          <option value={"part:module"}>Module</option>
          <option value={"part:mapsa"}>MaPSA</option>
          <option value={"part:ps-s"}>PS-s Sensor</option>
          <option value={"part:2sfeh"}>2S FEH</option>
          <option value={"part:psfeh"}>PS FEH</option>
          <option value={"part:seh"}>SEH</option>
          <option value={"part:vtrx"}>VTRX</option>
          <option value={"part:poh"}>POH</option>
          <option value={"part:roh"}>ROH</option>
          <option value={"part:baseplate"}>CFBaseplate</option>
        </Select>
      </HStack>

      {children}
      <Button type="submit" size="lg" variant="primary" onClick={doSearch}>
        Search
      </Button>
    </HStack>
  );
}
